import { SET_USERS } from "./actionTypes";

export const setUsersRedux = (users) => {
    localStorage.setItem("reduxUsers", JSON.stringify(users));
    return {
        type: SET_USERS,
        data: users
    }
}